import { render, staticRenderFns } from "./task-item.vue?vue&type=template&id=220bae38&"
import script from "./task-item.vue?vue&type=script&setup=true&lang=js&"
export * from "./task-item.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./task-item.vue?vue&type=style&index=0&id=220bae38&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports